ProjectPartShortInfoCtrl.$inject = [];

export function ProjectPartShortInfoCtrl() {}
